import BookForm from "../form/BookForm";

function AddBook() {

  //JSX
  return (
    <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
      <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
      <BookForm />
    </div>
  )
}

export default AddBook